<template>
<div class="chapter">
<div class="inner_page">
<p class="colophon"><span>Europa Editions<br/>
  214 West 29th St., Suite 1003<br/>
  New York NY 10001<br/>
  info@europaeditions.com<br/>
  www.europaeditions.com<br/>
<br/>
  This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously.<br/>
<br/>
  Copyright © 1977 by William McIlvanney<br/>
Published by arrangement with<br/>
Canongate Books Ltd,<br/>
14 High Street, Edinburgh EH1 1TE<br/>
<br/>
  All rights reserved, including the right of reproduction in whole or in part in any form.<br/>
<br/>
  Cover Art by Head Design<br/>
<br/>
  ISBN 9781609452636 <br/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Colophon.vue?4bda0649